import { useEffect, useState } from "react";
import { getProducts, getJournal } from "@/lib/api";
import { Overline } from "@/components/site/Primitives";
import { ProductCard } from "@/components/site/ProductCard";
import { NewsletterSection } from "@/components/site/Newsletter";
import { Reveal } from "@/lib/reveal";
import { Link } from "react-router-dom";

export default function ContentHub({ title, category, overline, intro, image }) {
  const [products, setProducts] = useState([]);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    getProducts({ category }).then(setProducts).catch(() => {});
    getJournal({ category }).then(setArticles).catch(() => {});
  }, [category]);

  return (
    <div data-testid={`hub-page-${category}`}>
      <section className="relative h-[55vh]">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-charcoal/40" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-7xl mx-auto px-6 md:px-10 w-full pb-14">
            <Overline className="text-brand-cream">{overline}</Overline>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light text-brand-cream mt-4 leading-none">{title}</h1>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-20 text-center">
        <p className="font-body text-brand-body text-xl leading-relaxed">{intro}</p>
      </section>

      {products.length > 0 && (
        <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20">
          <Reveal><Overline>From the Library</Overline><h2 className="text-4xl font-light mt-3 mb-12">Editions on this subject</h2></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
            {products.map((p, i) => <Reveal key={p.slug} delay={(i % 3) * 0.08}><ProductCard product={p} /></Reveal>)}
          </div>
        </section>
      )}

      {articles.length > 0 && (
        <section className="bg-brand-linen/40">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
            <Reveal><Overline>From the Journal</Overline><h2 className="text-4xl font-light mt-3 mb-12">Reading & wisdom</h2></Reveal>
            <div className="grid md:grid-cols-3 gap-10">
              {articles.map((a, i) => (
                <Reveal key={a.slug} delay={(i % 3) * 0.08}>
                  <Link to={`/journal/${a.slug}`} className="group block bg-brand-warm-white border border-brand-linen hover:border-brand-gold transition-colors duration-500">
                    <img src={a.cover} alt={a.title} className="w-full aspect-[3/2] object-cover" />
                    <div className="p-7">
                      <span className="overline text-[0.62rem]">{a.read_time}</span>
                      <h3 className="font-serif text-2xl mt-3 group-hover:text-brand-olive transition-colors">{a.title}</h3>
                      <p className="font-body text-brand-muted mt-3 leading-relaxed">{a.excerpt}</p>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}
      <NewsletterSection />
    </div>
  );
}
